




















































































import { Component, Mixins } from 'vue-mixin-decorator';
import { SlotMixin } from '@/mixins/SlotMixin';
import DefaultLayout from '@/views/layouts/DefaultLayout.vue';
import LogIn from '@/components/auth/LogIn.vue';
import { CUSTOMERS, ENTERPRISE, ENTERPRISE_PRODUCTS, OUTGOING_INVOICES, WORK } from '@/router/work';
import { Enterprise } from '@/resources/enterprise/Enterprise';
import { ENTERPRISE_REQUEST, GET_ENTERPRISE, GET_STATUS } from '@/store/models/work/enterprises';

@Component({
  components: { LogIn, DefaultLayout }
})

export default class WorkLayout extends Mixins<SlotMixin>(SlotMixin) {
  public loading ():null|boolean {
    return this.$store.getters[GET_STATUS];
  }

  protected drawer:boolean = false;

  public enterprise ():Enterprise {
    return this.$store.getters[GET_ENTERPRISE];
  }

  created () {
    this.$store.dispatch(ENTERPRISE_REQUEST, this.$route.params.enterprise);
    if (this.$route.name === 'work.enterprise') {
      this.$router.push({ name: ENTERPRISE });
    }
  }

  public items () {
    const params = { enterprise: this.$route.params.enterprise };
    return [
      { icon: 'home',
        text: 'Перегляд підприємства',
        to: {
          name: 'work.enterprise.show',
          params: params
        } },
      {
        icon: 'shopping_cart',
        text: 'Товари',
        to: {
          name: ENTERPRISE_PRODUCTS,
          params: params
        }
      },
      {
        icon: 'assignment_ind',
        text: 'Замовники',
        to: {
          name: CUSTOMERS,
          params: params
        }
      },
      {
        icon: 'expand_more',
        'icon-alt': 'expand_less',
        text: 'Накладні',
        model: false,
        children: [
          { text: 'Вихідні',
            icon: 'list_alt',
            to: {
              name: OUTGOING_INVOICES,
              params: params
            } },
          { text: 'Прихідні',
            icon: 'list_alt'
          }
        ]
      }
      /*,
      { icon: 'settings', text: 'Налаштування' },
      { icon: 'help', text: 'Допомога' } */
    ];
  }
}
